export class DsGroup {
  /**
   *
   */
  public groups_desc = '';

  /**
   *
   */
  public groups_id: number;

  /**
   *
   */
  public groups_label = '';

  /**
   *
   */
  public groups_level: number | null = null;

  /**
   *
   */
  public guid: number | null = null;

  /**
   *
   */
  public roles: number[] = [];

  /**
   *
   */
  public users: number[] = [];

  /**
   *Creates an instance of DsGroup.
   *
   * @param jsonData the json data
   */
  // TODO:  Set up the correct type
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(jsonData: any = {}) {
    this.groups_desc = jsonData.groups_desc || this.groups_desc;
    this.groups_id = jsonData.groups_id || this.groups_id;
    this.groups_label = jsonData.groups_label || this.groups_label;
    this.groups_level = jsonData.groups_level || this.groups_level;
    this.guid = jsonData.guid || this.guid;
    this.roles = jsonData.roles || this.roles;
    this.users = jsonData.users || this.users;
  }
}
